import angular from 'angular'
import routers from './routers.js'
import declareParamCtrl from './declareParamCtrl'
import declareParamEditCtrl from './declareParamEditCtrl'
import popUpEmployeCtrl from '../../personalIncomeTax/parameterConfiguration/popUpEmployeCtrl.js'

export default angular
  .module('declaration.vatDeclarationSurcharges.declareParam', [])
  .config([
    '$stateProvider',
    ($stateProvider) => {
      Object.keys(routers).forEach((router) => {
        $stateProvider.state(routers[router].state, routers[router].config)
      })
    },
  ])
  .controller('declareParamEditCtrl', declareParamEditCtrl)
  .controller('popUpEmployeCtrl', popUpEmployeCtrl)
  .controller('declareParamCtrl', declareParamCtrl).name



// WEBPACK FOOTER //
// ./src/app/declaration/vatDeclarationSurcharges/declareParam/index.js